import { render } from "./InstructionCard.vue?vue&type=template&id=1a0d37ad&scoped=true&ts=true"
import script from "./InstructionCard.vue?vue&type=script&lang=ts"
export * from "./InstructionCard.vue?vue&type=script&lang=ts"

import "./InstructionCard.vue?vue&type=style&index=0&id=1a0d37ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a0d37ad"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSpace,QBtn,QIcon,QDialog});
